/// <amd-module name="SuiteCommerce.SizeChart.Chart.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.Chart.Collection", ["require", "exports", "Backbone", "SuiteCommerce.SizeChart.Chart.Model", "SuiteCommerce.SizeChart.Common.Utils"], function (require, exports, Backbone_1, Chart_Model_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ChartCollection = /** @class */ (function (_super) {
        __extends(ChartCollection, _super);
        function ChartCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.url = Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/SuiteCommerce.SizeChart.Service.ss'));
            _this.model = Chart_Model_1.ChartModel;
            return _this;
        }
        return ChartCollection;
    }(Backbone_1.Collection));
    exports.ChartCollection = ChartCollection;
});
